// src/api/features/tours/dropdowns.ts

export const HOTEL_CATEGORIES = [
  "3 Star",
  "4 Star",
  "5 Star",
  "Boutique",
  "Apartment",
  "Villa",
] as const;

export type HotelCategory = (typeof HOTEL_CATEGORIES)[number];

export const ROOM_TYPES = [
  "Standard",
  "Superior",
  "Deluxe",
  "Suite",
  "Family Room",
] as const;

export type RoomTypePreset = (typeof ROOM_TYPES)[number];
